import { CALL_API } from 'redux-api-middleware'
import { get, post, destroy } from 'utils/network'

export const fetchBilling = (studentID) => {
  const request = get(`/billings/${studentID}`)
  request.types = ['BILL_REQ', 'BILL_GET_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const deleteFee = (studentID, billingID, id) => {
  const request = destroy(`/billings/${studentID}/${billingID}/${id}`)
  request.types = ['_REQ', 'BILL_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const addFee = (studentID, payload) => {
  const request = post(`/billings/${studentID}/add`, payload)
  request.types = ['_REQ', 'BILL_ADD_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Billing/actions.js